import type { IntakeSpec, PrintingDecorativeDetails } from '@shared/types';
import type { Part, Joint, Feature } from '@shared/spec';

function getDetails(intake: IntakeSpec): PrintingDecorativeDetails {
  return intake.details as PrintingDecorativeDetails;
}

export function parts(intake: IntakeSpec): Part[] {
  const d = getDetails(intake);
  return [
    {
      id: 'body',
      name: d.itemType,
      kind: 'custom',
      materialId: 'mat-primary',
      openscadSnippet: `// ${d.itemType} placeholder`,
      boundingBox: {
        w: intake.core.size?.length ?? 80,
        d: intake.core.size?.width ?? 80,
        h: intake.core.size?.height ?? 120,
      },
      position: [0, 0, 0],
      rotation: [0, 0, 0],
      tags: ['decorative'],
      paramRefs: [],
    },
  ];
}

export function joints(_intake: IntakeSpec): Joint[] {
  return [];
}

export function features(_intake: IntakeSpec): Feature[] {
  return [];
}
